// extracted by mini-css-extract-plugin
module.exports = {"root":"IconArrowHead_root__1QRpG"};